// @flow

/**
 * All functionality related to retrieving and supplying the app config
 * @module
 */

/**
 * Configuration object. Note that `initConfig()` must be called before this is populated
 * @summary Configuration object
 * @type {Object}
 */
export let Config: Object = {}

/**
 * Initialize `Config` object. Note that this needs to be called before any references to `Config` are used
 * @summary Initialize `Config` object
 * @returns {Promise<Config>} - Config Object
 */
export const initConfig = (): Promise<typeof Config> => {
  /** Desired hostname for config request (this is sometimes loaded as a blob in an iFrame) */
  const host: string = window.hostname ? 'https://' + window.hostname : ''

  if (Object.keys(Config).length === 0) {
    return fetch(host + '/env.json')
      .then(cfg => cfg.json())
      .then(cfg => {
        Config = cfg
        return Config
      })
  } else {
    return Promise.resolve(Config)
  }
}
